module.exports = __webpack_public_path__ + "static/Sample-1-7a40ad86a9a4a7b94f5c6b5340210b21.png";